import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "m3.938 5.305 1.667-1.667a.667.667 0 1 0-.943-.943L3.467 3.891l-.529-.53a.667.667 0 1 0-.943.944l1 1c.26.26.683.26.943 0M5.605 7.638a.667.667 0 1 0-.943-.943L3.467 7.891l-.529-.53a.667.667 0 1 0-.943.944l1 1c.26.26.683.26.943 0zM5.605 11.638l-1.667 1.667a.667.667 0 0 1-.943 0l-1-1a.667.667 0 1 1 .943-.943l.529.528 1.195-1.195a.667.667 0 1 1 .943.943M7.467 3.5a.667.667 0 0 0 0 1.333h6a.667.667 0 1 0 0-1.333zM6.8 8.167c0-.369.299-.667.667-.667h6a.667.667 0 1 1 0 1.333h-6a.667.667 0 0 1-.667-.666M7.467 11.5a.667.667 0 0 0 0 1.333h6a.667.667 0 1 0 0-1.333z"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })